import React from 'react';
import { Link } from 'react-router-dom';

import { colors, container, line } from '../theme';
import { footerColumns, logoWhite } from '../data';

export default function Footer() {
  return (
    <footer style={{ borderTop: line.faint }}>
      <div
        className="lyfe-wrap"
        style={{
          ...container,
          padding: '64px 40px 48px',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 48,
          flexWrap: 'wrap',
        }}>
        <div style={{ maxWidth: 300 }}>
          <img src={logoWhite} alt="Lyfe" style={{ height: 24, display: 'block', marginBottom: 18 }} />
          <p style={{ fontSize: 14, lineHeight: 1.6, color: colors.muted4 }}>
            The night starts right here, right now. Made for Miami nights.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 64, flexWrap: 'wrap' }}>
          {footerColumns.map((col) => (
            <div key={col.heading} style={{ display: 'flex', flexDirection: 'column', gap: 12, fontSize: 14 }}>
              <span
                style={{
                  color: colors.muted4,
                  fontSize: 12,
                  letterSpacing: '.14em',
                  textTransform: 'uppercase',
                  marginBottom: 4,
                }}>
                {col.heading}
              </span>
              {col.links.map((l) => (
                <a
                  key={l.label}
                  className="lyfe-link"
                  href={l.href}
                  {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                  {l.label}
                </a>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div
        className="lyfe-wrap"
        style={{
          ...container,
          padding: '24px 40px 48px',
          borderTop: '1px solid rgba(255,255,255,.06)',
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 16,
          color: colors.muted5,
          fontSize: 13,
        }}>
        <span>© 2026 Lyfe Social</span>
        <span style={{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
          <Link className="lyfe-link" to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className="lyfe-link" to="/terms-and-conditions">
            Terms &amp; Conditions
          </Link>
          <span>Made in Miami 🌙</span>
        </span>
      </div>
    </footer>
  );
}
